import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetEmpresaByPortalUsuarioId,} from '../shared/interfaces/configuracion';
import { PortalUsuarioEmpresaDto } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class PortalUsuarioEmpresaService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/usuario-empresa`;
  }

  getEmpresaByPortalUsuarioId(): Observable<IGetEmpresaByPortalUsuarioId[]> {
    return this.http.get<IGetEmpresaByPortalUsuarioId[]>(`${this.baseUrl}/get-empresas`);
  }

  registrarEmpresa(request: PortalUsuarioEmpresaDto, archivo: File): Observable<number> {
    const formData: FormData = new FormData();
    if (archivo)
      formData.append('archivo', archivo);
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return this.http.post<number>(`${this.baseUrl}/registrar-empresa`, formData);
  }

  actualizaEmpresa(request: PortalUsuarioEmpresaDto, id:number, archivo?: File): Observable<number> {
    const formData: FormData = new FormData();
    if (archivo)
      formData.append('archivo', archivo);
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return this.http.put<number>(`${this.baseUrl}/actualizar-empresa/${id}`, formData);
  }

  getDetalleEmpresasByUsuarioId():Observable<PortalUsuarioEmpresaDto[]>{
    return this.http.get<PortalUsuarioEmpresaDto[]>(`${this.baseUrl}/empresas`);
  }

}
